<template>
  <drag-modal :visible="$store.state.dislog.three" @cancel="reset" :title="'添加进度-' + litetit" width="860px"
    :class="{ editbox: Edit }">
    <div class="navbox" v-if="Edit">
      <Nscroll @getIndex="see" @delCopy="copydel" :openEdit="openEdit"></Nscroll>
      <div class="intopbtn" v-if="!isAllDis">
        <!-- <a-popconfirm title="确认新增此进度吗?" ok-text="确定" cancel-text="取消" @confirm="copyNew">
            <a-button icon="plus" v-if='!openEdit'>新增本进度</a-button>
          </a-popconfirm> -->
        <a-popconfirm title="确认删除当前进度吗?" ok-text="确定" cancel-text="取消" @confirm="delStep" v-if="
          $store.state.StepLite != 181 && $store.state.DisForm.infoList &&
          $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.del)
        ">
          <a-button type="danger" icon="delete" style="margin-left: 12px">删除</a-button>
        </a-popconfirm>
        <a-button icon="edit" v-if="
          $common.AccAUTH($store.state.cause.accuser.id, $store.getters.stepPower.edit) &&
          $store.getters.publicPower
        " style="margin-left: 10px" @click="openEdit = !openEdit">{{ openEdit ? '修改' : '取消修改' }}</a-button>
      </div>
    </div>
    <a-spin :spinning="loading">
      <div class="oneadd kbox">
        <a-form-model ref="forms" :model="form" :rules="openEdit ? {} : rules" :label-col="{ span: 12 }"
          :wrapper-col="{ span: 24 }">
          <!-- <div v-if='$store.state.StepLite==140'>
              <a-form-model-item label="立案方式：">
                <a-radio-group :options="plainOptions" v-model="form.type" @change='qtype' :disabled='openEdit' />
              </a-form-model-item>
              <div class="newtypelist">
                <div class="li" v-if='form.type==1'>
                  <a-form-model-item label="平台名称" prop="platform" :rules="{ required: true, message: '请输入平台名称',trigger: 'blur'}" style="margin-bottom:10px;" :label-col="{span: 12}" :wrapper-col="{span: 20}">
                    <a-select show-search placeholder="平台名称" option-filter-prop="children" style="width: 200px" :filter-option="filterOption" v-model='form.platform' :disabled='openEdit'>
                      <a-select-option :value="i" v-for='(i,index) in fy' :key='index'>
                        {{i}}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==1'>
                  <a-form-model-item label="材料提交时间" prop="time2" :rules="{ required: true, message: '请选择材料提交时间',trigger: 'change'}" :label-col="{span: 12}" :wrapper-col="{span: 20}">
                    <a-date-picker v-model="form.time2" placeholder="请选择" style="width: 100%;" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==2'>
                  <a-form-model-item label="单号" prop="ship_no" style="margin-bottom:10px;" :rules="{ required: true, message: '请输入单号',trigger: 'blur'}" :label-col="{span: 6}" :wrapper-col="{span: 20}">
                    <a-input v-model="form.ship_no" :disabled='openEdit' placeholder='请输入单号' />
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==2'>
                  <a-form-model-item label="联系方式" prop="tel" style="margin-bottom:10px;" :rules="{ required: true, message: '请输入联系方式',trigger: 'blur'}" :label-col="{span: 6}" :wrapper-col="{span: 20}">
                    <a-input v-model="form.tel" :disabled='openEdit' placeholder='请输入联系方式' />
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==2'>
                  <a-form-model-item label="材料名称" prop="filename" :rules="{ required: true, message: '请输入材料名称',trigger: 'blur'}" :label-col="{span: 10}" :wrapper-col="{span: 20}">
                    <a-input v-model="form.filename" :disabled='openEdit' placeholder='请输入材料名称' />
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==2'>
                  <a-form-model-item label="收件人" prop="receive_name" :rules="{ required: true, message: '请输入收件人',trigger: 'blur'}" :label-col="{span: 10}" :wrapper-col="{span: 20}">
                    <a-input v-model="form.receive_name" :disabled='openEdit' placeholder='请输入收件人' />
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==2'>
                  <a-form-model-item label="寄出时间" prop="ship_time" style="margin-bottom:10px;" :rules="{ required: true, message: '请选择寄出时间',trigger: 'change'}" :label-col="{span: 10}" :wrapper-col="{span: 20}">
                    <a-date-picker v-model="form.ship_time" placeholder="请选择" style="width: 100%;" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==2'>
                  <a-form-model-item label="" :label-col="{span: 8}" :wrapper-col="{span: 20}">
                    <a-radio-group v-model='form.gout' :disabled='openEdit'>
                      <a-radio :value="'a'">签收时间</a-radio>
                      <a-radio :value="'b'">拒收时间</a-radio>
                    </a-radio-group>
                    <a-date-picker v-model="form.receive_time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' v-if='form.gout=="a"' :disabled='openEdit' />
                    <a-date-picker v-model="form.return_time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' v-else />
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==2'>
                  <a-form-model-item label="收件地址" prop="addr" :rules="{ required: true, message: '请输入收件地址',trigger: 'blur'}" :label-col="{span: 10}" :wrapper-col="{span: 20}">
                    <a-input v-model="form.addr" :disabled='openEdit' placeholder='请输入收件地址' />
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==1 || form.type==2'>
                  <a-form-model-item label="备注" prop="comment" :rules="{ required: false, message: '请输入备注',trigger: 'blur'}" :label-col="{span: 10}" :wrapper-col="{span: 20}">
                    <a-input v-model="form.comment" :disabled='openEdit' placeholder='请输入备注' />
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==3'>
                  <a-form-model-item label="立案时间" prop="time2" :rules="{ required: true, message: '请选择立案时间',trigger: 'change'}" :label-col="{span: 8}" :wrapper-col="{span: 20}">
                    <a-date-picker v-model="form.time2" placeholder="请选择" style="width: 100%;" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==3'>
                  <a-form-model-item label="补充地点" prop="location" :rules="{ required: false, message: '请输入补充地点',trigger: 'blur'}" :label-col="{span: 6}" :wrapper-col="{span: 20}">
                    <a-input v-model="form.location" :disabled='openEdit' placeholder='请输入单号' />
                  </a-form-model-item>
                </div>
                <div class="li" v-if='form.type==3'>
                  <a-form-model-item label="提交人" prop="submiter" :rules="{ required: false, message: '请输入提交人',trigger: 'blur'}" :label-col="{span: 6}" :wrapper-col="{span: 20}">
                    <a-input v-model="form.submiter" :disabled='openEdit' placeholder='请输入单号' />
                  </a-form-model-item>
                </div>
              </div>
              <div class="newtypelist">
                <div class="li">
                  <a-form-model-item label="管辖法院" :label-col="{span: 10}" :wrapper-col="{span: 24}">
                    <div class="fyinput">
                      {{$store.state.cause.court}}
                    </div>
                  </a-form-model-item>
                </div>
                <div class="li">
                  <a-form-model-item label="立案庭联系方式" prop='court_tel' :label-col="{span: 10}" :wrapper-col="{span: 20}" style="margin-top:10px;" :rules="{ required: false, message: '请输入立案联系方式',trigger: 'blur'}">
                    <a-input style="width:200px;" v-model="form.court_tel" placeholder="请输入联系方式" :disabled='openEdit' />
                  </a-form-model-item>
                </div>
              </div>
            </div> -->
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="立案时间" prop="time" labelAlign="left" :rules="{
                required: true,
                message: '请选择立案时间',
                trigger: 'change',
              }">
                <a-date-picker v-model="form.time" :placeholder="!openEdit ? '请选择立案时间' : ''" format="YYYY-MM-DD" type="date"
                  valueFormat="YYYY-MM-DD HH:mm:ss" :disabled="openEdit" style="width: 100%" />
              </a-form-model-item>
            </a-col>
            <!-- </a-row>
          <a-row> -->
            <a-col :span="8">
              <!-- v-if='$store.state.StepLite==80 || $store.state.StepLite==140' -->
              <a-form-model-item label="案号" labelAlign="left">
                <div v-for="(i, index) in form.no" :key="index" class="morebar"
                  style=" display: flex; align-items: center; margin-bottom: 10px; ">
                  <a-input v-model="i.v" :placeholder="!openEdit ? '请输入案号' : ''" :disabled="openEdit"
                    style="width: 100%" />
                  <div class="btns" v-if="!openEdit">
                    <a-icon type="plus-circle" class="i add" @click="add" v-if="index == 0"
                      style="margin-right: 10px" />
                    <a-icon type="minus-circle" class="i del" @click="dels(index)" v-else />
                  </div>
                </div>
              </a-form-model-item>
              <!-- <a-form-model-item label="案号" style="max-width:564px;" v-else>
                  <span>{{$store.state.cause.no}}</span>
                </a-form-model-item> -->
            </a-col>
          </a-row>
          <div>
            <div class="licter" v-if="!openEdit">
              <label>补充材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon" style="margin-bottom:5px;">
              <div class="ilikebox" v-for="(i, index) in form.supp" :key="index">
                <div class="likebox" v-if="i.type == 1">
                  <div class="htit">
                    补充材料：电子
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="平台名称" :prop="'supp.' + index + '.platform'" :rules="{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.platform" :disabled="openEdit" placeholder="请输入平台名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :label-col="{ span: 6 }" :wrapper-col="{ span: 24 }"
                        :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 2">
                  <div class="htit">
                    补充材料：微信
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="对方微信号" :prop="'supp.' + index + '.wx'" :rules="{
                        required: true,
                        message: '请输入对方微信号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.wx" :disabled="openEdit" placeholder="请输入对方微信号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :label-col="{ span: 8 }" :wrapper-col="{ span: 24 }"
                        :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 3">
                  <div class="htit">
                    补充材料：现场
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="补充提交人" :prop="'supp.' + index + '.submiter'" :rules="{
                        required: true,
                        message: '请输入补充提交人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.submiter" :disabled="openEdit" placeholder="请输入补充提交人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="补充时间" :prop="'supp.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择补充时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择补充时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 4">
                  <div class="htit">
                    补充材料：邮寄
                    <span @click="del(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="单号" :prop="'supp.' + index + '.ship_no'" :rules="{
                        required: true,
                        message: '请输入单号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.ship_no" :disabled="openEdit" placeholder="请输入单号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                          <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                        </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'supp.' + index + '.tel'" :rules="{
                        required: true,
                        message: '请输入联系方式',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.tel" :disabled="openEdit" placeholder="请输入联系方式" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'supp.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="收件人" :prop="'supp.' + index + '.receive_name'" :rules="{
                        required: true,
                        message: '请输入收件人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.receive_name" :disabled="openEdit" placeholder="请输入收件人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="寄出时间" :prop="'supp.' + index + '.ship_time'" :rules="{
                        required: true,
                        message: '请选择寄出时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="">
                        <label v-if="openEdit">{{
                          i.gout == 'a'
                            ? '签收时间:'
                            : i.gout == 'b'
                              ? '拒收时间:'
                              : '无'
                        }}</label>
                        <a-radio-group v-model="i.gout" :disabled="openEdit" style="white-space: nowrap" size="small"
                          v-else>
                          <a-radio-button :value="null"
                            style=" width: 64px;  text-align: center;font-size: 0.75rem;">无</a-radio-button>
                          <a-radio-button :value="'a'"
                            style="width: 65px;   font-size: 0.75rem;text-align: center; ">签收时间</a-radio-button>
                          <a-radio-button :value="'b'"
                            style="width: 65px; font-size: 0.75rem;text-align: center; ">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="i.gout == 'a'"
                          :disabled="openEdit" style="width: 100%" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" v-if="i.gout == 'b'" />
                        <a-input disabled v-if="!i.gout" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="收件地址" :prop="'supp.' + index + '.addr'" :rules="{
                        required: true,
                        message: '请输入收件地址',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.addr" :disabled="openEdit" type="textarea" placeholder="请输入收件地址" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="备注" :prop="'supp.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
            <div class="licter" v-if="!openEdit">
              <label>接收材料:</label>
              <div class="rmain">
                <a href="javascript:void(0);" @click="plusAdd(1, 1)">电子</a>
                <a href="javascript:void(0);" @click="plusAdd(2, 1)">微信</a>
                <a href="javascript:void(0);" @click="plusAdd(3, 1)">现场</a>
                <a href="javascript:void(0);" @click="plusAdd(4, 1)">邮寄</a>
              </div>
            </div>
            <div class="ilikecon">
              <div class="ilikebox" v-for="(i, index) in form.accept_file" :key="index">
                <div class="likebox" v-if="i.type == 1">
                  <div class="htit">
                    接收材料：电子
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="平台名称" :prop="'accept_file.' + index + '.platform'" :rules="{
                        required: true,
                        message: '请输入平台名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.platform" :disabled="openEdit" placeholder="请输入平台名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 2">
                  <div class="htit">
                    接收材料：微信
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="对方微信号" :prop="'accept_file.' + index + '.wx'" :rules="{
                        required: true,
                        message: '请输入对方微信号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.wx" :disabled="openEdit" placeholder="请输入对方微信号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 3">
                  <div class="htit">
                    接收材料：现场
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.submiter'" :rules="{
                        required: true,
                        message: '请输入接收人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.submiter" :disabled="openEdit" placeholder="请输入接收人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="接收时间" :prop="'accept_file.' + index + '.time'" :rules="{
                        required: true,
                        message: '请选择接收时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.time" placeholder="请选择接收时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
                <div class="likebox" v-if="i.type == 4">
                  <div class="htit">
                    接收材料：邮寄
                    <span @click="supdel(index)" v-if="!openEdit">
                      <a-icon type="minus-circle" />
                    </span>
                  </div>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="单号" :prop="'accept_file.' + index + '.ship_no'" :rules="{
                        required: true,
                        message: '请输入单号',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.ship_no" :disabled="openEdit" placeholder="请输入单号" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <!-- <a-form-model-item label="补充时间" :label-col="{span: 8}" :wrapper-col="{span: 20}" :prop="'supp.' + index + '.time'" :rules="{ required: true, message: '请选择补充时间',trigger: 'change'}">
                          <a-date-picker v-model="i.time" placeholder="请选择" show-time type="date" valueFormat="YYYY-MM-DD HH:mm:ss" format='YYYY-MM-DD HH:mm' :disabled='openEdit' />
                        </a-form-model-item> -->
                      <a-form-model-item label="联系方式" :prop="'accept_file.' + index + '.tel'" :rules="{
                        required: true,
                        message: '请输入联系方式',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.tel" :disabled="openEdit" placeholder="请输入联系方式" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="材料名称" :prop="'accept_file.' + index + '.filename'" :rules="{
                        required: true,
                        message: '请输入材料名称',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.filename" :disabled="openEdit" placeholder="请输入材料名称" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="8">
                      <a-form-model-item label="接收人" :prop="'accept_file.' + index + '.receive_name'" :rules="{
                        required: true,
                        message: '请输入接收人',
                        trigger: 'blur',
                      }">
                        <a-input v-model="i.receive_name" :disabled="openEdit" placeholder="请输入接收人" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="寄出时间" :prop="'accept_file.' + index + '.ship_time'" :rules="{
                        required: true,
                        message: '请选择寄出时间',
                        trigger: 'change',
                      }">
                        <a-date-picker v-model="i.ship_time" placeholder="请选择寄出时间" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="8">
                      <a-form-model-item label="">
                        <label v-if="openEdit">{{
                          i.gout == 'a'
                            ? '签收时间:'
                            : i.gout == 'b'
                              ? '拒收时间:'
                              : '无'
                        }}</label>
                        <a-radio-group v-model="i.gout" :disabled="openEdit" size="small" style="white-space: nowrap"
                          v-else>
                          <a-radio-button :value="null" style="
                                width: 64px;
                                text-align: center;
                                font-size: 0.75rem;
                              ">无</a-radio-button>
                          <a-radio-button :value="'a'" style="
                                width: 65px;
                                font-size: 0.75rem;
                                text-align: center;
                              ">签收时间</a-radio-button>
                          <a-radio-button :value="'b'" style="
                                width: 65px;
                                font-size: 0.75rem;
                                text-align: center;
                              ">拒收时间</a-radio-button>
                        </a-radio-group>
                        <a-date-picker v-model="i.receive_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" v-if="i.gout == 'a'"
                          :disabled="openEdit" style="width: 100%" />
                        <a-date-picker v-model="i.return_time" placeholder="请选择" show-time type="date"
                          valueFormat="YYYY-MM-DD HH:mm:ss" format="YYYY-MM-DD HH:mm:ss" :disabled="openEdit"
                          style="width: 100%" v-if="i.gout == 'b'" />
                        <a-input disabled v-if="!i.gout" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row :gutter="24">
                    <a-col :span="12">
                      <a-form-model-item label="收件地址" :prop="'accept_file.' + index + '.addr'" :label-col="{ span: 12 }"
                        :wrapper-col="{ span: 24 }" :rules="{
                          required: true,
                          message: '请输入收件地址',
                          trigger: 'blur',
                        }">
                        <a-input v-model="i.addr" :disabled="openEdit" type="textarea" placeholder="请输入收件地址" />
                      </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-model-item label="备注" :prop="'accept_file.' + index + '.comment'"
                        :label-col="{ span: 12 }" :wrapper-col="{ span: 24 }">
                        <a-input v-model="i.comment" :disabled="openEdit" type="textarea" placeholder="请输入备注" />
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
          </div>
          <a-form-model-item :label-col="{ span: 24 }" prop="files" :rules="{
            required: false,
            message: '请上传附件',
            trigger: 'change',
          }">
            <Upload @isDisabled="parentHandle" :fList="List" @upFileAfter="lisUpload" :disabled="openEdit" :edit="openEdit"
              v-if="!loading" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 24 }" v-if="!openEdit" style="text-align: center">
            <a-popconfirm :disabled="disabledShow" title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
              <a-button type="primary" style="width: 148px" :disabled="disabledShow"> 提交 </a-button>
            </a-popconfirm>
            <a-button style="
                  margin-left: 20px;
                  width: 148px;
                  background: #b2c9e1;
                  color: #fff;
                " @click="reset">取消</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-spin>
  </drag-modal>
</template>

<script>
import Nscroll from '@/components/nscroll'
import Upload from '@/components/uploads'
import { convertToFullwidthBrackets } from "@/assets/js/caseNumber"
import {
  mapGetters,
  mapActions
} from 'vuex'
import {
  laAdd,
  laEdit,
  laDetails, delJd
} from '@/server/speed'
export default {
  name: "Three",
  computed: {
    ...mapGetters(['litetit', 'Edit']),
  },
  components: {
    Upload,
    Nscroll,
  },
  data() {
    return {
      List: [],
      isAllDis: this.$route.query.t,
      loading: true,
      openEdit: false,
      plainOptions: [{
        label: '网立',
        value: 1
      },
      {
        label: '邮寄',
        value: 2
      },
      {
        label: '现场',
        value: 3
      },
      ],
      form: {
        supp: [],
        accept_file: [],
        no: [{
          v: null
        }],
        type: 1, //补充材料类型
        platform: null, //平台名称
        time: null, //时间
        ship_no: null, //单号
        ship_time: null, //签收时间
        files: [], //附件
        court_tel: null,
        submiter: null,
        location: null,
        time2: null,
        gout: 'a',
      },
      rules: {},
      disabledShow: false
    }
  },
  created() {
    if (this.Edit) {
      this.$nextTick(() => {
        laDetails({
          cause_id: this.$store.state.cause.id,
          step: this.$store.state.StepLite,
        }).then((e) => {
          // if (this.$store.state.StepLite == 80 || this.$store.state.StepLite == 140) {
          //   e.list.map(ele => {
          //     ele.la.no = ele.la.no ? ele.la.no.split(",").map(ele => { return { v: ele } }) : [{ v: '' }]
          //   })
          // }
          e.list.map((ele) => {
            // ele.la.supp = Object.keys(ele.la.supp).map(key => ele.la.supp[key])
            ele.la.supp = Object.keys(ele.la.supp).map(key => {
              const item = ele.la.supp[key];

              // 添加 gout 属性
              item.gout = item.receive_time ? 'a' :
                item.return_time ? 'b' :
                  null;

              return item;
            });
            // ele.la.accept_file = Object.keys(ele.la.accept_file).map(key => ele.la.accept_file[key])
            ele.la.accept_file = Object.keys(ele.la.accept_file).map(key => {
              const item = ele.la.accept_file[key];

              // 添加 gout 属性
              item.gout = item.receive_time ? 'a' :
                item.return_time ? 'b' :
                  null;

              return item;
            });
            ele.la.no = ele.la.no ?
              ele.la.no.split(',').map((ele) => {
                return {
                  v: ele
                }
              }) :
              [{
                v: ''
              }]
          })
          this.$store.dispatch("settime", e.list[0].la.update_time)
          this.Infokey({
            key: 'infoList',
            value: e.list
          })
          this.see(0)
        })
        this.openEdit = true
      })
    } else {
      this.loading = false
    }
  },
  methods: {
    convertToFullwidthBrackets,
    parentHandle(data) {
      this.disabledShow = data
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      )
    },
    qtype(e, val) {
      //切换清除
      let keyArr = ['platform', 'time', 'ship_no', 'ship_time']
      keyArr.map((ele) => {
        this.form[ele] = null
      })
      this.$refs.forms.clearValidate(keyArr)
    },
    ...mapActions({
      Newdel: 'DisForm/copydel',
      seeInfo: 'DisForm/see',
      addNew: 'DisForm/addNew',
      Infokey: 'DisForm/setInfokey',
      reMove: 'DisForm/reMove',
    }),
    del(index) {
      let supp = JSON.parse(JSON.stringify(this.form.supp))
      supp.splice(index, 1)
      this.form.supp = supp
    },
    supdel(index) {
      let supp = JSON.parse(JSON.stringify(this.form.accept_file))
      supp.splice(index, 1)
      this.form.accept_file = supp
    },
    plusAdd(type, lite) {
      let smForm = {
        type: type,
      }
      if (type == 4) {
        smForm.gout = null
      }
      if (lite) {
        this.form.accept_file.push(smForm)
      } else {
        this.form.supp.push(smForm)
      }
    },
    delStep() {
      let curIndex = this.$store.state.DisForm.curIndex
      let step_id = this.$store.state.DisForm.infoList[curIndex].id
      delJd({ step_id: step_id }).then(e => {
        this.$message.success("已提交审核")
        setTimeout(e => {
          window.history.go(0)
        }, 500)
      })
    },
    async copydel(index) {
      //删除进度
      let keylist =
        this.$store.state.StepLite == 80 ?
          ['no', 'time', 'files'] :
          ['time', 'files']
      if (this.$store.state.StepLite == 140) {
        keylist = [
          'platform',
          'time',
          'time2',
          'ship_no',
          'receive_time',
          'supp',
          'files',
          'court_tel',
          'type',
          'ship_time',
          'submiter',
          'location',
          'filename',
          'receive_name',
          'addr',
        ]
      }
      this.loading = true
      await this.Newdel({
        index: index,
        formKey: keylist,
        valkey: 'la'
      }).then(
        (e) => {
          this.form = JSON.parse(JSON.stringify(e))
          this.loading = false
        }
      )
    },
    async see(index) {
      //查看切换 审批
      // let keylist = this.$store.state.StepLite == 80 || this.$store.state.StepLite == 140 ? ["no", "time", "files"] : ["time", "files"]
      let keylist = ['no', 'time', 'files', 'supp', 'accept_file']
      // if (this.$store.state.StepLite == 140) {
      //   keylist = ["platform", "time", "time2", "ship_no", "receive_time", "supp", "files", "court_tel", "type", "ship_time", "submiter", 'location', 'filename', 'receive_name', 'addr', 'tel', 'comment', 'return_time']
      // }
      this.loading = true
      let form = this.form
      this.seeInfo({
        index: index,
        formKey: keylist,
        valkey: 'la'
      }).then(
        (e) => {
          let form = JSON.parse(JSON.stringify(e))
          form.gout = form.receive_time ? 'a' : 'b'
          form.files.map((ele) => {
            ele.title = ele.origin_name || ele.title
            ele.upload_id = ele.upload_id
            ele.id = ele.id
          })
          this.List = form.files
          this.form = form
          this.loading = false
        }
      )
    },
    add() {
      this.form['no'].push({
        v: ''
      })
    },
    dels(index) {
      this.form['no'].splice(index, 1)
    },
    confirm() {
      this.$refs.forms.validate((valid) => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form))
          if (form.gout == 'a') {
            form.return_time = null
          } else if (form.gout == 'b') {
            form.receive_time = null
          }
          delete form.gout
          // if (this.$store.state.StepLite == 80 || this.$store.state.StepLite == 140) {
          //   form.no = form.no.map(ele => {
          //     return ele.v
          //   }).join(",")
          // }
          // else {
          //   form.no = this.$store.state.cause.no
          // }
          const firNo = form.no.length > 0 ? form.no[0].v : null
          form.no = form.no.map(ele => {
              if (ele.v) {
                ele.v = this.convertToFullwidthBrackets(ele.v)
                return ele.v.replace(/\s/g, '')
              }
              return null
            })
            .filter(Boolean) // ✅ 过滤空值、空字符串、null、undefined
            .join(',')
          for (let val in form) {
            if (!form[val]) {
              delete form[val]
            }
          }
          if (form.files && form.files.length > 0) {
            form.files = form.files.map((ele) => {
              return ele.upload_id || ele
            })
          }
          // if (this.$store.state.StepLite != 140) {
          //   delete form.type
          // }
          form.supp.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })
          form.accept_file.map(ele => {
            if (ele.type == 4) {
              if (ele.gout == "a") {
                delete ele.return_time
              } else if (ele.gout == "b") {
                delete ele.receive_time
              } else {
                delete ele.return_time
                delete ele.receive_time
              }
              delete ele.gout
            }
          })
          delete form.type
          let curIndex = this.$store.state.DisForm.curIndex   //当前案件索引
          let isEditCopyAdd =
            this.$store.state.DisForm.copyIndex.indexOf(curIndex) >= 0 ?
              true :
              false //当前是否是在修改下的新增
          if (this.Edit && !isEditCopyAdd) {
            //修改
            let id = this.$store.state.DisForm.infoList[curIndex].la.id
            form.id = id
            // return false;
            laEdit(form).then((e) => {
              this.$message.success({
                content: '修改成功',
                key: 'updatable'
              })
              this.$parent.$parent.init(this.$store.state.cause.id)
              if ((this.$store.state.StepLite == 30 || this.$store.state.StepLite == 33) && firNo) {
                this.$store.dispatch('Case/putInData', { index: this.$store.getters.debIndex, key: "no", value: firNo })
              }
              this.$parent.$parent.init(this.$store.state.cause.id)
              this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          } else {
            form.cause_id = this.$store.state.cause.id
            form.step = this.$store.state.StepLite
            laAdd(form).then((e) => {
              this.$message.success({
                content: '新增成功',
                key: 'updatable'
              })
              this.$parent.$parent.init(this.$store.state.cause.id);
              if ((this.$store.state.StepLite == 30 || this.$store.state.StepLite == 33) && firNo) {
                this.$store.dispatch('Case/putInData', { index: this.$store.getters.debIndex, key: "no", value: firNo })
              }
              this.$parent.$parent.init(this.$store.state.cause.id)
              this.$store.dispatch("Case/getlist", { debtor_id: this.$route.params.id })
              this.reset()
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    reset() {
      this.reMove().then((e) => {
        // this.$refs.forms.resetFields(); //TODO
        this.$store.dispatch('openkey', {
          key: 'three',
          by: false
        })
      })
    },
    lisUpload(fileList) {
      this.form.files = fileList
    },
  },
}
</script>

<style lang="less" scoped>
.kbox {
  .ant-form-item {
    margin: 4px !important;

    &:nth-last-child(1) {
      margin: 0;
    }
  }
}

.oneadd {
  margin-bottom: 20px;
}

.ilikecon {
  max-height: 400px;
  overflow: auto;
}

.likebox {
  padding: 20px;
  background: #f3f6fb;
  margin-bottom: 10px;
  border-radius: 8px;

  .htit {
    font-size: 1rem;
    color: #0e2949;
    line-height: 19px;
    margin-bottom: 12px;

    span {
      color: #f00;
      cursor: pointer;
    }
  }

  /deep/ .ant-form-item {
    margin-bottom: 0;
  }

  /deep/ .ant-form-item-label {
    text-align: left;
  }
}

.licter {
  overflow: hidden;
  margin-bottom: 20px;
  display: flex;
  align-items: center;

  label {
    float: left;
    font-size: 0.875rem;
    // text-align: right;
    width: 60px;
    color: #333;
    line-height: 30px;
    margin-right: 10px;
  }

  .clearbtn {
    float: left;
  }

  .rmain {
    // padding-left: 20px;
    // margin-left: 20px;
    float: left;

    a {
      width: 68px;
      line-height: 36px;
      background: #b2c9e1;
      border-radius: 4px;
      display: inline-block;
      margin-right: 20px;
      font-size: 0.875rem;
      color: #fff;
      text-align: center;
      transition-duration: 500ms;

      &:hover {
        background: #1d8bfe;
      }
    }
  }
}

.morebar {
  display: flex;
  margin-bottom: 20px;
  height: 40px;
  align-items: center;
  position: relative;

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
}

.btns {
  position: absolute;
  right: -45px;
  top: 50%;
  transform: translateY(-50%);
  width: 15%;
  display: flex;
  font-size: 1.25rem;
  justify-content: space-between;
  // padding-left: 20px;
  height: 30px;
  align-items: center;

  .i {
    cursor: pointer;
  }

  .add {
    color: #118afc;
  }

  .del {
    color: #f00;
  }
}
</style>
